
















































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';

@Component({ name: 'AccountTimeline' })
export default class extends SaascadaVue {

    @Prop({required: false})
    currentTestDateUtc: Date;

    async mounted() {
        if (this.fixedTermValues && this.fixedTermMaturityValues) {

            // The date now will either be the test date if there is one, or the actual date now
            const now = this.currentTestDateUtc ? new Date(this.currentTestDateUtc) : new Date();

            // Calculate which point to fill the timeline to based on all of the date variables
            const createdAtDate = new Date(this.createdAtDate);
            const fundingWindowStartDate = new Date(this.fixedTermValues.fundingWindowStartDateUtc);
            const fundingWindowEndDate = new Date(this.fixedTermValues.fundingWindowEndDateUtc);
            const maturityWindowStartDate = new Date(this.fixedTermMaturityValues.maturityWindowStartDateUtc);
            const maturityDate = new Date(this.fixedTermMaturityValues.maturityDateUtc);

            if ((now > createdAtDate) && (now <= fundingWindowStartDate)) {
                this.partiallyFillSegment("initialDepositWindow", now, createdAtDate, fundingWindowStartDate);
            }
            else if ((now > fundingWindowStartDate) && (now <= fundingWindowEndDate)) {
                // When the date now is in the funding window
                this.completelyFillSegment("initialDepositWindow");
                this.partiallyFillSegment("fundingWindow", now, fundingWindowStartDate, fundingWindowEndDate);
            }
            else if ((now > fundingWindowEndDate) && (now <= maturityWindowStartDate)) {
                // When the date now is after the funding window but before the maturity window
                this.completelyFillSegment("initialDepositWindow");
                this.completelyFillSegment("fundingWindow");
                this.partiallyFillSegment("fixedTerm", now, fundingWindowEndDate, maturityWindowStartDate);
            }
            else if ((now > maturityWindowStartDate) && (now <= maturityDate)) {
                // When the date now is after the maturity window but before the maturity date
                this.completelyFillSegment("initialDepositWindow");
                this.completelyFillSegment("fundingWindow");
                this.completelyFillSegment("fixedTerm");
                this.partiallyFillSegment("maturityWindow", now, maturityWindowStartDate, maturityDate);
            }
            else {
                // At the end of the full term
                this.completelyFillSegment("initialDepositWindow");
                this.completelyFillSegment("fundingWindow");
                this.completelyFillSegment("fixedTerm");
                this.completelyFillSegment("maturityWindow");
            }
        }
    }

    partiallyFillSegment(segmentId: string, nowDate: Date, segmentStartDate: Date, segmentEndDate: Date) {
        // Calculates the length of the segment based on dates given
        const numberOfMillisecondsInSegment = segmentEndDate.getTime() - segmentStartDate.getTime();
        const numberOfDaysInSegment = Math.ceil(numberOfMillisecondsInSegment / (1000 * 3600 * 24));
        // Calculate the total number of days passed so far
        const numberOfMillisecondsPasssed = nowDate.getTime() - segmentStartDate.getTime();
        const numberOfDaysPassed = Math.ceil(numberOfMillisecondsPasssed / (1000 * 3600 * 24));
        // Calculate those two numbers as a percentage and fill the segment by that amount
        const segmentFillAsAPercentage = (numberOfDaysPassed/numberOfDaysInSegment) * 100;
        const segment = document.getElementById(segmentId);
        segment.style.setProperty("--width", `${segmentFillAsAPercentage}%`);
    }

    completelyFillSegment(segmentId: string) {
        const segment = document.getElementById(segmentId);
        segment.classList.add("fill")
    }

    get createdAtDate() {
        return DepositAccountModule.depositAccount.createdAt;
    }

    get fixedTermValues() {
        return DepositAccountModule.depositAccount.accountValues?.depositFixedTermValues;
    }

    get fixedTermMaturityValues() {
        return DepositAccountModule.depositAccount.accountValues?.depositFixedTermMaturityValues;
    }

}
